import { Lock } from "lucide-react";

interface ReassuranceLineProps {
  text: string;
  className?: string;
}

export function ReassuranceLine({ text, className = "" }: ReassuranceLineProps) {
  return (
    <p
      className={`flex items-center justify-center gap-1.5 text-sm text-gray-500 ${className}`}
      style={{ fontFamily: "TT Commons Pro" }}
    >
      <Lock className="w-3.5 h-3.5 flex-shrink-0" aria-hidden="true" />
      {text}
    </p>
  );
}
